import React, { Component } from 'react';
import {Input,Button,Dropdown,DropdownMenu,DropdownToggle} from 'reactstrap';
import DatePicker from 'react-datepicker';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';

class SetGoal extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      showSetGoalDropdown : false,
      showOptionsDropdown : false,
      error : false,
      errorDetail : null,
      errorType:"",
      activeGoal : {
        _id:"", createdDate:"", kpiId:"", name:" ", number:"", year: "",
      },
      number : '',
      year: "",
      id: "",
      inProgress : false
    }
    this.goal = {
      _id:"", createdDate:"", kpiId:"", name:" ", number:"", year: "",
    };
  }

  componentDidMount() {
    let goalData = get(this.props, 'goalData')
    this.setState({
      activeGoal : goalData ? goalData : {...this.goal},
      number : goalData ?  goalData.number : "",
      year : goalData ? goalData.year : "",
      id: goalData ? goalData._id : ""
    })
}

componentWillReceiveProps(nextProps) {
  if(!this.state.showSetGoalDropdown) {
  this.setState({
    activeGoal : nextProps.goalData ? nextProps.goalData : {...this.goal},
    number : nextProps.goalData ?  nextProps.goalData.number : "",
    year : nextProps.goalData ? nextProps.goalData.year : "",
    id: nextProps.goalData ? nextProps.goalData._id : ""
  })
}
}


  /**
   * Updating goal value
   */
  handleGoalValueChange = ({target}) => {
    let { value } = target;

    if(!isNaN(value) && (value <= 100 && value >= 0)) {
      this.setState({
          error : false,
          errorDetail : null,
          number : value
      })
    } else {
      this.setState({ error : true, errorDetail : 'Please use only numbers, 0-100' });
    }
  }

  /**
   * Updating goal Date
   */
  handleGoalDateChange = (date) => {
    const {kpi} = this.props;

    this.setState({ 
        year : date.format("MM/DD/YYYY")
    })
  }

  handleSetGoal = (kpiId) => {    
    const {isEdit} = this.state;
    let { activeGoal, number, year} = this.state;
    const _id = activeGoal ? activeGoal._id :""

    const temp = {...activeGoal};

    if(!number){
        this.setState({
          error : true,
          errorDetail : 'Please enter a value',
          errorType: "number"
        });
        return;
    }

    if(!year) {
      this.setState({
        error : true,
        errorDetail : 'Please select a date',
        errorType: "date"
      });
      return;
    }

  
    if(number && year){
      temp.number = number;
      temp.year = year;
      
      if (isEdit===true){
        this.setState({
          isEdit : false,
        });  
        temp._id = _id;
        this.props.onSetGoal(kpiId,true,temp);
      } else {
        this.setState({
          isEdit : false,
        });
        temp.kpiId = kpiId.id;
        temp.name = kpiId.name;
        this.props.onSetGoal(kpiId,false, temp);
      }

      this.setState({
        showSetGoalDropdown : false,
        error : false,
        errorDetail : null
      });  
    } 
  }

  handleEditClick = () => {
    const goalData = this.state.activeGoal ? this.state.activeGoal : {...this.goal};
    this.setState({
      activeGoal : goalData ? goalData : {...this.goal},
      number : goalData ?  goalData.number : "",
      year : goalData ? goalData.year : "",
      id: goalData ? goalData._id : ""
    })
    this.toggle();
    this.setState({showSetGoalDropdown : true, isEdit:true});
  }

  handleDeleteGoal = (goalId) => {
    this.toggle();
    this.setState({
      activeGoal : {...this.goal},
      number: "",
      year: "",
      id: "",
      isEdit : false
    });
    this.props.onDeleteGoal(goalId);
  }

  toggle = () => {
    const {showOptionsDropdown} = this.state;
    this.setState({
      showOptionsDropdown : !showOptionsDropdown
    });
  }

  handleCancelClick = (kpiId) => {
    const goalData = this.state.activeGoal ? this.state.activeGoal : {...this.goal};
    this.setState({
        showSetGoalDropdown : false,
        errorType: "",
        error : false, 
        errorDetail : null, 
        activeGoal: goalData,
        number: goalData.number,
        year: goalData.year
    })
  }

  handleDatePicker = (id) => {
    document.getElementById(id).click();
  }


  render() { 
    const { kpi, goalData } = this.props;
    const {showSetGoalDropdown,error,errorDetail,errorType,isEdit , activeGoal, number, year } = this.state;
    
    return ( 
      <div key={kpi.name} 
        style={{border:'1px solid #C3C4C7',borderRadius:'5px'}}>
        <div className="chartGoalOptionsKPIName">
          {kpi.name}
        </div>
        <hr style={{margin:'0px 0px !important',borderTop:'1px solid #C3C4C7',}}/>
        {
          number !== "" && !showSetGoalDropdown ?
          <div className="goals-title">
            <div>
              {number}% by {year}
            </div>
            <div >
            <Dropdown isOpen={this.state.showOptionsDropdown} 
              toggle={this.toggle}
              style={{display:this.props.canSetGoals ? 'block':'none'}}
              >
              <DropdownToggle
                tag="span"
                className="chart-item-menu"
                onClick={this.toggle}
                data-toggle="dropdown"
                aria-expanded={this.state.showOptionsDropdown}
                >
                <i className="flaticon-menu" style={{cursor:'pointer'}}></i>
              </DropdownToggle>
              <DropdownMenu right className="set-goal-dropdown">
                <div className="row" 
                  style={{paddingLeft:'32px',marginRight:'0px'}}
                   onClick={this.handleEditClick}>
                    <i className="goal-dropdown flaticon-edit"></i>
                    <span className="goal-dropdown-item">
                      Edit
                    </span>
                </div>
                <div className="row" 
                  style={{paddingLeft:'32px',marginRight:'0px'}} 
                  onClick={() => this.handleDeleteGoal(goalData)}>
                    <i className="goal-dropdown flaticon-minus"></i>
                    <span className="goal-dropdown-item">
                      Delete Goal
                    </span>
                </div>
              </DropdownMenu>
            </Dropdown>
            </div>
          </div> :
          <div 
            onClick={() => {this.setState((prevState) => 
              ({showSetGoalDropdown : !prevState.showSetGoalDropdown}))}}
              className="goals-title"
            style={{color:'#5099DE',
            display:showSetGoalDropdown ? 'none' : 'block',cursor:'pointer'}}>
            Set a Goal for this KPI
          </div>
        }
        <div style={{display:showSetGoalDropdown ? 'block' : 'none',
          padding:'10px 30px',paddingBottom:'0px'}}>
          <div>
            <div className="row">
              <div className="col-lg-10 pr5">
                <Input 
                  className="set-goal-input set-goal-value"
                  placeholder={"Enter goal value"}
                  onChange={this.handleGoalValueChange}
                  value={this.state.number}
                  invalid={errorType==="number"?error:null}
                  style={{height:'25px',border:'1px solid #C3C4C7'}}/>
             
              </div>
              <div className="col-lg-2 pl0">%</div>
            </div>
            <div className={errorType==="date"?"inner-addon right-addon goalDateError":"inner-addon right-addon" } style={{marginTop:'10px'}}>
              <span className="set-goal-date flaticon-calendar" onClick={() => this.handleDatePicker(this.props.goalIndex)}/>
              <DatePicker
                id={this.props.goalIndex}
                placeholderText="Enter goal date"
                className="set-goal input-custom-date form-control"
                selected={this.state.year ? 
                  moment(new Date(this.state.year) ) : null}
                onChange={this.handleGoalDateChange}
                showYearDropdown
              />
              
            </div>
            {
                  error ? <span className="goal-input-error">{errorDetail}</span> : null
                }
            <div className="row" style={{justifyContent:'center'}}>
              <span 
                onClick={() => this.handleSetGoal(kpi)}
                className="set-goal-button chartGoalOptions">
                {
                  isEdit ? `Save` : `Set Goal`
                }
              </span>
              <span 
                className="cancel-set-goal-button chartGoalOptions"
                onClick={() => this.handleCancelClick(kpi)}>
                Cancel
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
 
export default SetGoal;